import React from 'react'
import { LightButton, PrimaryButton } from '../AllButtons/AllButtons'
import { useNavigate } from 'react-router-dom';
import { RootState, useAppSelector } from '../../Store/store';
import MathRenderer from '../CommonElements/MathRenderer';

interface ConfirmTopicProps {
  confirmDetails: {
    conversation_id: string;
    topic: string;
    topic_description: string;
    subject:string;
  };
  setChatDisable?: (disable: boolean) => void; 
  setShowTopic?: (disable: boolean) => void; 
}
const ConfirmTopic: React.FC<ConfirmTopicProps> = ({ confirmDetails,setChatDisable,setShowTopic }) => {
  const user = useAppSelector((state: RootState) => state.user.user);
  const navigate = useNavigate();
  const handleClick =()=>{
    if (user.remaining_tokens <= 0) {
      navigate("/price/chat");
    } else {
      navigate("/test");
    }
  }

 const handleContinueChat = () => {
  if (setChatDisable) {
    setChatDisable(false);
    setShowTopic?.(false);
  }
}

  return (
    <div><div className="confirmation-card mt-4">
                          <div className="confirmation-card-title">
                            Let's Confirm Your Topic
                          </div>
                          <div className="confirmation-card-dsc">
                            YULI identified the following subject from your
                            request. Is this correct?
                          </div>
                          <div className="equation-block">
                            <div className="equation-block-label">
                             {confirmDetails?.subject}
                            </div>
                            <div className="equation-block-title">
                               <MathRenderer text={confirmDetails?.topic} />
                            </div>
                            <div className="equation-block-dsc">
                               <MathRenderer text={confirmDetails?.topic_description} />
                            </div>
                          </div>
                          <div className="info-block">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <g clipPath="url(#clip0_5895_3627)">
                                <path
                                  d="M8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM6.75 10.5H7.5V8.5H6.75C6.33437 8.5 6 8.16562 6 7.75C6 7.33437 6.33437 7 6.75 7H8.25C8.66562 7 9 7.33437 9 7.75V10.5H9.25C9.66562 10.5 10 10.8344 10 11.25C10 11.6656 9.66562 12 9.25 12H6.75C6.33437 12 6 11.6656 6 11.25C6 10.8344 6.33437 10.5 6.75 10.5ZM8 4C8.26522 4 8.51957 4.10536 8.70711 4.29289C8.89464 4.48043 9 4.73478 9 5C9 5.26522 8.89464 5.51957 8.70711 5.70711C8.51957 5.89464 8.26522 6 8 6C7.73478 6 7.48043 5.89464 7.29289 5.70711C7.10536 5.51957 7 5.26522 7 5C7 4.73478 7.10536 4.48043 7.29289 4.29289C7.48043 4.10536 7.73478 4 8 4Z"
                                  fill="#8A6FE8"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_5895_3627">
                                  <rect width="16" height="16" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                            Your test will include 5 MCQs + 5 Open-ended
                            questions to match your level. This will help YULI
                            understand your strengths and areas for improvement.
                          </div>
                          <div className="confirmation-card-footer">
                            {/* <LightButton>No, Let Me Rephrase</LightButton> */}
                            <LightButton onClick={handleContinueChat}>No, Let Me Rephrase</LightButton>
                            <PrimaryButton onClick={handleClick}>Yes, Start Diagnostic Test</PrimaryButton>
                          </div>
                        </div></div>
  )
}

export default ConfirmTopic